// FLAGS: none
// Confirmation dialog shown when the operator closes the session-details form with unsaved changes.
import React from "react";
import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "@openup/shared/components/Button/Button";
import Header from "./Header";
import Footer from "./Footer";

interface CancelWhileEditModalProps {
  isOpen?: boolean;
  handleCancelWithoutSaving?: () => void;
  handleContinueEditing?: () => void;
}

const CancelWhileEditModal: React.FC<CancelWhileEditModalProps> = ({
  isOpen = false,
  handleCancelWithoutSaving = () => {},
  handleContinueEditing = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} classes={{ paper: "absolute p-0" }}>
      <Header
        headerStyle="py-2 px-3"
        leftChildren={
          <p className="sub1">
            {t("SessionNotes.UnsavedChangesWarningHeader")}
          </p>
        }
      />
      <hr />
      <p className="body1 py-4 px-3">
        {t("SessionNotes.UnsavedChangesWarningBody")}
      </p>
      <hr />
      <Footer
        footerStyle="p-2"
        leftChildren={
          <Button variant="secondary" onClick={handleContinueEditing}>
            {t("SessionNotes.UnsavedChangesGoBack")}
          </Button>
        }
        rightChildren={
          <Button variant="primary" onClick={handleCancelWithoutSaving}>
            {t("SessionNotes.UnsavedChangesDiscard")}
          </Button>
        }
      />
    </Dialog>
  );
};

export default CancelWhileEditModal;
